<template>
  <v-container class="pa-0 vote-poll">
    <v-alert v-if="errMsg !== ''" type="error" text dismissible>{{
      errMsg
    }}</v-alert>
    <v-row no-gutters class="mb-6" align="center">
      <v-col><h2>List poll</h2></v-col>
      <v-col cols="auto"
        ><v-btn
          text
          :color="$buttonColor"
          outlined
          class="create-poll mr-4"
          small
          @click="refresh()"
        >
          <v-icon size="small" class="mr-1">fas fa-redo</v-icon>
          Refresh
        </v-btn></v-col
      >
      <v-col cols="auto"
        ><v-btn
          text
          :color="$buttonColor"
          outlined
          class="create-poll"
          small
          @click="dialogAddPoll = true"
        >
          <v-icon size="large" class="mr-1">mdi-plus</v-icon>
          Create poll
        </v-btn></v-col
      >
    </v-row>

    <!-- Polls -->
    <div v-if="!_.isEmpty(polls)">
      <div class="poll" v-for="poll in polls" :key="poll._id">
        <v-row align="center" no-gutters class="mb-3">
          <v-col class="shrink justify-center mr-4">
            <v-avatar color="grey" size="40">
              <v-img :src="poll.creator.image"></v-img>
            </v-avatar>
          </v-col>
          <v-col>
            <div class="body-2">
              <strong class="mr-1">{{
                poll.creator.firstName + ' ' + poll.creator.lastName
              }}</strong>
              <span>create a poll</span>
            </div>
            <div v-if="poll.created_at" class="text-caption font-weight-light">
              {{ poll.created_at | moment('from', 'now') }}
            </div>
          </v-col>
        </v-row>

        <div class="body-1 mb-3">{{ poll.question }}</div>

        <div v-if="poll.isMultipleOption" class="checkbox">
          <v-row v-for="choice in poll.choices" class="choice mb-3" align="center" no-gutters
              :key="choice._id">
            <v-col class="pr-3">
              <v-checkbox
                class="pa-0 ma-0"
                hide-details=""
                v-model="choice.voted"
                :key="choice._id"
                @change="vote(poll._id, poll.choices)"
              >
                <template v-slot:label>
                  <v-row no-gutters align="baseline" class="px-2">
                    <v-col
                      class="pr-2"
                      :cols="choice.created_by === info._id ? 'auto' : ''"
                      ><div class="body-2">{{ choice.text }}</div></v-col
                    >
                    <v-col class="pr-2" v-if="choice.created_by === info._id">
                      <div class="text-caption font-weight-light">
                        ( Add by you )
                      </div>
                    </v-col>
                    <v-col cols="auto" v-if="choice.count > 0">
                      <div class="text-caption font-weight-light">
                        ( {{ choice.count }}&nbsp;voted )
                      </div>
                    </v-col>
                    <v-progress-linear
                      :value="choice.percent"
                    ></v-progress-linear>
                      </v-row>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="auto" v-if="choice.created_by === info._id">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="remove-choice"
                    @click="removeChoice(poll._id, choice._id)"
                  >
                    <v-icon fab small>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Remove option</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row
            v-if="poll.canAddMoreChoice"
            align="center"
            no-gutters
            class="choice add-choice-text mb-3"
          >
            <v-col cols="auto"
              ><v-icon class="icon-type"
                >mdi-checkbox-blank-outline</v-icon
              ></v-col
            >
            <v-col class="pr-4">
              <v-text-field
                hide-details=""
                dense
                placeholder="Add option"
                class="pa-0 ma-0"
                v-model="addCheckboxChoice"
              ></v-text-field>
            </v-col>
            <v-col cols="auto">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    class="add-choice"
                    v-bind="attrs"
                    v-on="on"
                    @click="insertChoice(poll._id, addCheckboxChoice)"
                  >
                    <v-icon color="primary" fab>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add option</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>

        <v-radio-group
          v-else
          class="ma-0 pa-0"
          hide-details=""
          :v-model="
            !_.isEmpty(poll.choices)
              ? poll.choices.find((c) => c.voted === true)
              : ''
          "
          @change="
            (newModel) => {
              changeRadio(newModel, poll._id);
            }
          "
        >
          <!-- vote(poll._id, poll.choices) -->
          <v-row v-for="choice in poll.choices"
            :key="choice._id"
            class="choice mb-3" align="center" no-gutters>
            <v-col class="pr-3">
              <v-radio :value="choice._id">
                <template v-slot:label>
                  <v-row no-gutters align="baseline" class="px-2">
                    <v-col
                      class="pr-2"
                      :cols="choice.created_by === info._id ? 'auto' : ''"
                      ><div class="body-2">{{ choice.text }}</div></v-col
                    >
                    <v-col class="pr-2" v-if="choice.created_by === info._id">
                      <div class="text-caption font-weight-light">
                        ( Add by you )
                      </div>
                    </v-col>
                    <v-col cols="auto" v-if="choice.count > 0">
                      <div class="text-caption font-weight-light">
                        {{ choice.count }}&nbsp;point{{
                          choice.count > 1 ? 's' : ''
                        }}
                      </div>
                    </v-col>
                    <v-progress-linear
                      :value="choice.percent"
                    ></v-progress-linear>
                  </v-row>
                </template>
              </v-radio>
            </v-col>
            <v-col cols="auto" v-if="choice.created_by === info._id">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="remove-choice"
                    @click="removeChoice(poll._id, choice._id)"
                  >
                    <v-icon fab small>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Remove option</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row
            v-if="poll.canAddMoreChoice"
            align="center"
            no-gutters
            class="choice add-choice-text mb-3"
          >
            <v-col cols="auto"
              ><v-icon class="icon-type"
                >mdi-checkbox-blank-circle-outline</v-icon
              ></v-col
            >
            <v-col class="pr-4">
              <v-text-field
                hide-details=""
                dense
                placeholder="Add option"
                class="pa-0 ma-0"
                v-model="addRadioChoice"
              ></v-text-field>
            </v-col>
            <v-col cols="auto">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    class="add-choice"
                    v-bind="attrs"
                    v-on="on"
                    @click="insertChoice(poll._id, addRadioChoice)"
                  >
                    <v-icon color="primary" fab>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add option</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-radio-group>
      </div>
    </div>

    <!-- No Data -->
    <div v-else-if="!loading">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="48px"
          >mdi-text-box-remove-outline</v-icon
        >
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีแบบสำรวจให้แสดง</div>
      </v-row>
    </div>

    <!-- Dialog Add Poll -->
    <v-dialog v-model="dialogAddPoll" scrollable max-width="900px">
      <v-card class="vote-poll">
        <v-card-title>
          <v-row no-gutters>
            <v-col><span class="question-title">Add poll</span></v-col>
            <v-col cols="auto">
              <v-btn icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-card class="pa-5" elevation="0" color="grey lighten-5">
            <p class="body-1 font-weight-medium">Poll</p>
            <v-textarea
              hide-details=""
              v-model="questionText"
              name="input-7-4"
              solo
            ></v-textarea>
          </v-card>

          <v-card class="pa-5" tile elevation="0">
            <v-row no-gutters align="center">
              <v-col
                ><p class="body-1 font-weight-medium mb-0">
                  Option type
                </p></v-col
              >
              <v-col>
                <v-select
                  v-model="select"
                  hide-details=""
                  :items="items"
                  :prepend-icon="
                    this.select.value == 'MULTIPLE'
                      ? 'mdi-radiobox-marked'
                      : 'mdi-check-box-outline'
                  "
                  item-text="title"
                  item-value="value"
                  return-object
                  class="pa-0 ma-0"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters align="center">
              <v-col>
                <p class="body-1 font-weight-medium mb-0">
                  Vote closing time
                </p>
              </v-col>
              <v-col
                ><v-datetime-picker
                  clearText="Clear"
                  okText="Ok"
                  v-model="datetime"
                >
                </v-datetime-picker
              ></v-col>
            </v-row>
            <v-row no-gutters align="center">
              <v-col>
                <p class="body-1 font-weight-medium mb-0">
                  Allow others to add option
                </p>
              </v-col>
              <v-col class="py-0">
                <v-checkbox
                  class="mt-0"
                  v-model="allowAddChoice"
                  label="Allow"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card>

          <v-card class="pa-5" elevation="0" color="grey lighten-5">
            <p class="body-1 font-weight-medium">Options</p>
            <div v-if="select.value === 'SINGLE'" class="checkbox">
              <v-checkbox
                class="choice mb-3"
                v-for="(answer, index) in answers"
                :key="index + '_vote_poll_dialog'"
                hide-details=""
                v-model="answer.voted"
              >
                <template v-slot:label>
                  <v-row align="center" no-gutters>
                    <v-col class="pr-4">
                      <v-row no-gutters align="baseline" class="px-2">
                        <v-col class="pr-2"
                          ><div class="body-2">{{ answer.text }}</div></v-col
                        >
                      </v-row>
                    </v-col>
                    <v-col cols="auto">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            class="remove-choice"
                          >
                            <v-icon fab small>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove option</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </template>
              </v-checkbox>

              <v-row align="center" no-gutters class="choice add-choice-text">
                <v-col cols="auto"
                  ><v-icon class="icon-type"
                    >mdi-checkbox-blank-outline</v-icon
                  ></v-col
                >
                <v-col class="pr-4">
                  <v-text-field
                    hide-details=""
                    dense
                    placeholder="Add option"
                    class="pa-0 ma-0"
                    v-model="newPollAddCheckboxChoice"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        class="add-choice"
                        v-bind="attrs"
                        v-on="on"
                        @click="newPollInsertChoice(newPollAddCheckboxChoice)"
                      >
                        <v-icon color="primary" fab>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Add option</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>

            <v-radio-group v-else class="ma-0 pa-0" hide-details="">
              <!-- vote(poll._id, poll.choices) -->
              <v-radio
                class="choice mb-3"
                v-for="(answer, index) in answers"
                :key="index + '_vote_poll_dialog'"
              >
                <template v-slot:label>
                  <v-row align="center" no-gutters>
                    <v-col class="pr-4">
                      <v-row no-gutters align="baseline" class="px-2">
                        <v-col class="pr-2"
                          ><div class="body-2">{{ answer.text }}</div></v-col
                        >
                      </v-row>
                    </v-col>
                    <v-col cols="auto">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            class="remove-choice"
                          >
                            <v-icon fab small>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove option</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </template>
              </v-radio>

              <v-row align="center" no-gutters class="choice add-choice-text">
                <v-col cols="auto"
                  ><v-icon class="icon-type"
                    >mdi-checkbox-blank-circle-outline</v-icon
                  ></v-col
                >
                <v-col class="pr-4">
                  <v-text-field
                    hide-details=""
                    dense
                    placeholder="Add option"
                    class="pa-0 ma-0"
                    v-model="newPollAddRadioChoice"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        class="add-choice"
                        v-bind="attrs"
                        v-on="on"
                        @click="newPollInsertChoice(newPollAddRadioChoice)"
                      >
                        <v-icon color="primary" fab>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Add option</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-row justify="end" no-gutters>
            <v-col cols="auto">
              <v-btn outlined @click="closeDialog">Cancel</v-btn>
            </v-col>
            <v-col cols="auto pl-3">
              <v-btn :color="$buttonColor" @click="savePoll">
                <v-icon left>mdi-check</v-icon>Save</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';

export default {
  props: ['setLoading'],
  data() {
    return {
      url: 'https://us-central1-deknerd-556e6.cloudfunctions.net/votePoll',
      polls: [],
      loading: true,
      errMsg: '',
      info: {},
      addRadioChoice: '',
      addCheckboxChoice: '',
      dialogAddPoll: false,
      questionText: '',
      answerText: '',
      select: {
        title: 'Multiple option',
        value: 'MULTIPLE',
      },
      items: [
        {
          title: 'Multiple option',
          value: 'MULTIPLE',
        },
        {
          title: 'Checkbox',
          value: 'SINGLE',
        },
      ],
      datetime: '',
      allowAddChoice: false,
      answers: [],
      newPollAddCheckboxChoice: '',
      newPollAddRadioChoice: '',
    };
  },
  computed: {
    idlivestream() {
      return this.$store.getters.liveId;
    },
  },
  mounted() {
    this.info = Vue.prototype.$userInfo;
    this.getPolls();
  },
  methods: {
    refresh() {
      this.getPolls();
    },
    savePoll() {
      let choices = this.answers.map(a => a.text);
      let question = {
        livestream: this.$store.getters.liveId,
        question: this.questionText,
        choices,
        time: 3000,
        isMultipleOption: this.select.value !== 'MULTIPLE',
        canAddMoreChoice: this.allowAddChoice,
        creator: this.created_by()
      };
      Vue.axios
        .post(
          `${this.url}-insertPoll`,question,
          this.$store.getters.requestHeaders,
        )
        .then((res) => {
          this.closeDialog();
          this.answers = [];
          this.questionText = '';
          this.allowAddChoice = false;
          this.select.value = 'MULTIPLE';
          this.getPolls();
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    removeChoice(idpoll, idchoice) {
      const data = {
        idlivestream: this.idlivestream,
        idpoll,
        idchoice
      }

      const url = this.$store.getters.urlQueryParameter(`${this.url}-deleteChoice`, data);

      Vue.axios
        .delete(
          url,data,
          this.$store.getters.requestHeaders,
        )
        .then((res) => {
          console.log(res)
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    getPolls() {
      this.setLoading(true);
      const url = this.$store.getters.urlQueryParameter(`${this.url}-getPoll`, {
        idlivestream: this.idlivestream,
        limit: 100,
        page: 1,
      });

      Vue.axios
        .get(url, this.$store.getters.requestHeaders)
        .then((res) => {
          this.polls = res.data.result.data;
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    changeRadio(value, pollId) {
      console.log('valuevaluevaluevalue', value);
      let targetUpdatePoll = this.polls.filter((poll) => poll._id === pollId);
      if (targetUpdatePoll.length > 0) {
        targetUpdatePoll[0].choices.forEach((choice) => {
          choice.voted = choice._id === value;
        });
        this.vote(pollId, targetUpdatePoll[0].choices);
      }
    },
    created_by() {
      return {
        _id: this.info._id,
        firstName: this.info.firstName,
        lastName: this.info.lastName,
        image: this.info.image
      }
    },
    vote(pollId, choices) {
      this.setLoading(true);
      const voted = choices.filter((c) => c.voted === true).map((v) => v._id);
      Vue.axios
        .post(`${this.url}-vote`, {
          idlivestream: this.idlivestream,
          pollId,
          choices: voted,
          creator: this.created_by()
        })
        .then((res) => {
          this.updateChoiceInPoll(pollId, res);
          this.setLoading(false);
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    updateChoiceInPoll(pollId, res) {
      const data = res.data;
      let targetUpdatePoll = this.polls.filter((poll) => poll._id === pollId);
      let newChoices = data.result.choices;
      if (data && data.status === true && data.result && data.result.choices) {
        if (targetUpdatePoll.length > 0) {
          targetUpdatePoll[0].choices = newChoices;
        }
      }
    },
    insertChoice(idpoll, choice) {
      Vue.axios
        .post(
          `${this.url}-insertChoice`,
          {
            idlivestream: this.idlivestream,
            idpoll,
            choice,
          },
          this.$store.getters.requestHeaders,
        )
        .then((res) => {
          this.addRadioChoice = '';
          this.addCheckboxChoice = '';
          this.updateChoiceInPoll(idpoll, res);
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    deleteChoice() {
      Vue.axios
        .delete(`${this.url}-deleteChoice`, this.$store.getters.requestHeaders)
        .then((res) => {})
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    insertPoll(choice) {
      Vue.axios
        .post(
          `${this.url}-insertPoll`,
          {
            livestream: this.idlivestream,
            question: 'newest1319',
            choices: ['choice1', 'choice2'],
            time: 30000,
            isMultipleOption: true,
            creator: {
              _id: '5ea544c4e24227fd209e0e03',
              firstName: 'เนิร์ดออฟ',
              lastName: 'ดอทคอม',
              image:
                'https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/6e9e813f-e37e-4549-a3bf-f2c4ead0c83c.png',
            },
          },
          this.$store.getters.requestHeaders,
        )
        .then((res) => {})
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    newPollInsertChoice(text) {
      console.log('answer answer answer');
      this.answers.push({ text });
      this.newPollAddCheckboxChoice = '';
      this.newPollAddRadioChoice = '';
    },
    closeDialog() {
      this.dialogAddPoll = false;
    },
  },
};
</script>
<style lang="scss">
.vote-poll {
  .choice {
    .v-progress-linear {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100% !important;
      border-radius: 4px;
      opacity: 0.16;
    }

    .row {
      position: relative;
    }

    .col {
      z-index: 1;
    }

    button {
      width: auto !important;
      height: auto !important;
      background: initial !important;
      border-radius: 50% !important;

      &.remove-choice {
        opacity: 0;
      }
    }

    &:hover {
      .remove-choice {
        opacity: 1;
      }
    }
  }

  .add-choice-text {
    margin-top: 0 !important;
    padding-top: 0 !important;

    .v-input__slot {
      min-height: initial !important;
    }

    input {
      font-size: 0.875rem !important;
      padding: 4px 8px !important;
    }

    .icon-type {
      font-size: 28px;
      margin: 0 8px 0 -2px;
    }
  }

  .checkbox .v-input__slot {
    margin: 0 !important;
  }

  .no-data {
    color: #e1e2e6;
  }

  .poll {
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 24px;
    padding-bottom: 24px;

    &:last-child {
      margin: 0;
      padding: 0;
      border: none;
    }
  }

  .create-poll {
    background: initial !important;
    font-size: inherit !important;
    border-color: initial !important;
    border-radius: 4px !important;
  }

  button.error--text {
    background: transparent;
  }
}
</style>
